import React from 'react';
import { Container, Grid, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function AboutSection() {
  const theme = useTheme();

  return (
    <Box id="about" component="section" sx={{ py: 12, backgroundColor: 'transparent' }}>
      <Container>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="overline" sx={{ color: theme.palette.primary.main, letterSpacing: 3, mb: 2, display: 'block' }}>
              ABOUT THE STUDIO
            </Typography>
            <Typography variant="h4" sx={{ fontFamily: theme.typography.h1?.fontFamily, color: 'text.primary', mb: 3 }}>
              The Genesis of the Studio
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.primary', opacity: 0.88, mb: 2 }}>
              This studio was born from a singular, uncompromising vision: to bridge the gap between structural integrity and poetic design. Founded on pure determination and an unwavering obsession with spatial narrative, the practice operates on the belief that space design is not just about dressing a room—it is about uncovering its inherent story.
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.primary', opacity: 0.88 }}>
              What began as a passionate, independent pursuit of architectural excellence has evolved into a boutique design studio known for its focused, deliberate, and deeply personal approach to modern spaces.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ position: 'relative', width: '100%', borderRadius: 2, overflow: 'hidden' }}>
              <Box
                component="img"
                src={`/gallery/segments/Elevation2.jpeg`}
                alt="Modern interior"
                sx={{ width: '100%', height: 'auto', borderRadius: '4px' }}
              />
              {/* <Box
                sx={{
                  position: 'absolute',
                  right: 16,
                  bottom: 16,
                  bgcolor: 'rgba(18,18,18,0.85)',
                  color: '#E5E5E5',
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                  fontSize: '0.75rem',
                  letterSpacing: 2,
                }}
              >
                STUDIO EST. 2024
              </Box> */}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
